import { Pipe, PipeTransform } from '@angular/core';
import { DocumentTypeEnum } from '@domain';

@Pipe({
    name: 'iconColorByDocumentType',
    standalone: true,
})
export class IconColorByDocumentTypePipe implements PipeTransform {
    /**
     * Formata a cor do ícone de acordo com o tipo de documento
     * @param type Tipo de documento
     * @returns Cor do ícone, ou a cor de documento normal se não houver tipo
     */
    transform(type: DocumentTypeEnum | null | undefined): string {
        switch (type) {
            case DocumentTypeEnum.QUOTE:
                return 'accentOrange';
            case DocumentTypeEnum.CONTRACT:
                return 'accentGreen';
            default:
                return 'accentBlue';
        }
    }
}
